/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { QueryClient, QueryKey, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import fetch from "../../clients/content-ai-api-client";
import { stationConfigGet } from "../axios/stationConfigGet";
import type { StationConfigGetPathParams, StationConfigGetQueryResponse } from "../models/StationConfigGet";

export const stationConfigGetQueryKey = (stationId: StationConfigGetPathParams["stationId"]) => ["content-ai-api", { url: '/station-config/:stationId', params: {stationId:stationId} }] as const

export type StationConfigGetQueryKey = ReturnType<typeof stationConfigGetQueryKey>

export function stationConfigGetQueryOptions(stationId: StationConfigGetPathParams["stationId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = stationConfigGetQueryKey(stationId)
  return queryOptions<StationConfigGetQueryResponse, ResponseErrorConfig<Error>, StationConfigGetQueryResponse, typeof queryKey>({
   enabled: !!(stationId),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return stationConfigGet(stationId, config)
   },
  })
}

/**
 * @summary Get station config for client user
 * {@link /station-config/:stationId}
 */
export function useStationConfigGet<TData = StationConfigGetQueryResponse, TQueryData = StationConfigGetQueryResponse, TQueryKey extends QueryKey = StationConfigGetQueryKey>(stationId: StationConfigGetPathParams["stationId"], options:
{
  query?: Partial<QueryObserverOptions<StationConfigGetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? stationConfigGetQueryKey(stationId)

  const query = useQuery({
   ...stationConfigGetQueryOptions(stationId, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}